import Banner from "../../components/Bannar/Bannar";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/index";
import Auction_card from "../../components/Auction_Card";
import { cardData, categoryData } from "../../constant/fake-data";
import Slider from "react-slick";
import AuctionSlider from "../../components/Auction_Card";
import { IMAGES } from "../../constant/Image";
import Button from "../../components/Button/index";
import { Link } from "react-router-dom";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M0 7.49991L9 15L3.27273 7.49991L9 0L0 7.49991Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

const Home = () => {
  // Auction Slider Settings
  const auctionSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  // Category Slider Settings (Custom)
  const categorySettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div>
      <Header />
      <Banner />

      {/* Upcoming Auction */}
      <section className="upcoming-auction">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div
                className="starting-a-bid-box"
                style={{
                  backgroundImage: `url(${IMAGES.Start_a_bid_img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <AuctionSlider item={cardData[0]} />
              </div>
            </div>
            <div className="col-md-9">
              <div className="text">
                <div className="bottom-line">
                  <h2>
                    Upcoming <span>Auction</span>
                  </h2>
                </div>
              </div>
              <Slider {...auctionSettings}>
                {cardData.map((val) => (
                  <AuctionSlider item={val} key={val.id} />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Auction */}
      <section className="upcoming-auction latest-auction">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <div className="bottom-line bottom-line-non">
                  <h2>
                    Latest <span>Auction</span>
                  </h2>
                </div>
              </div>
              <Slider {...auctionSettings}>
                {cardData.map((val) => (
                  <AuctionSlider item={val} key={val.id} />
                ))}
              </Slider>

              <div className="t-btn-center">
                <Button
                  text="View All Auctions"
                  primary={true}
                  icon={true}
                  onClick={() => console.log("View All Auctions clicked")}
                  style={{ fill: "black" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hot Product */}
      <section
        className="hot-product"
        style={{
          backgroundImage: `url(${IMAGES.car_bg_banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="starting-a-bid-box hot-product-box"
                style={{
                  backgroundImage: `url(${IMAGES.car_bg_img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <AuctionSlider item={cardData[0]} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Category Slider */}
      <section className="category-slider">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <div className="bottom-line bottom-line-non">
                  <h2>
                    Auction <span>Category</span>
                  </h2>
                </div>
              </div>
              <Slider {...categorySettings}>
                {categoryData.map((cat) => (
                  <div key={cat.id} style={{ padding: "0 0.5rem" }}>
                    <Link
                      to={`/category/${cat.name.toLowerCase()}`}
                      style={{
                        display: "block",
                        textAlign: "center",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "1rem",
                        background: "#fff",
                        textDecoration: "none",
                        color: "#000",
                      }}
                    >
                      <img
                        src={cat.image}
                        alt={cat.name}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "contain",
                          marginBottom: "0.5rem",
                        }}
                      />
                      <h3>{cat.name}</h3>
                      <p>{cat.items}</p>
                    </Link>
                  </div>
                ))}
              </Slider>

              <div className="t-btn-center">
                <Button
                  text="View All Auctions"
                  primary={true}
                  icon={true}
                  onClick={() => console.log("View All Auctions clicked")}
                  style={{ fill: "black" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="upcoming-auction popular-auction">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="vertical-align-box">
                <div className="text">
                  <h6>
                    Highest <span>Bidding.</span>
                  </h6>
                </div>
                <div className="row">
                  {cardData.slice(0, 3).map((val) => (
                    <div className="col-md-12 mb-12" key={val.id}>
                      <AuctionSlider item={val} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="boxes-two-align">
                <div className="t-btn-center">
                  <Button
                    text="View All Auctions"
                    primary={true}
                    icon={true}
                    onClick={() => console.log("View All Auctions clicked")}
                    style={{ fill: "black" }}
                  />
                </div>
                <div className="text text-align">
                  <div className="bottom-line">
                    <h2>
                      Popular Auction <span>For You.</span>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row colum-card-style">
                {cardData.slice(0, 6).map((val) => (
                  <div className="col-md-4 mb-4" key={val.id}>
                    <AuctionSlider item={val} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="step-section"
        style={{
          backgroundImage: `url(${IMAGES.step_images})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="car-imag-top">
            <img src={IMAGES.step_top_img} alt="" />
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <h2>
                  03 Step Of Our Work <span>Process</span>
                </h2>
              </div>
              <div className="three-box-align">
                <div className="arrow-imgs-abs">
                  <img
                    className="curve_arrow_top_down"
                    src={IMAGES.curve_arrow_top_down}
                    alt=""
                  />

                  <img
                    className="curve_arrow_dowm_top"
                    src={IMAGES.curve_arrow_dowm_top}
                    alt=""
                  />
                </div>
                <div className="image-box">
                  <div className="img">
                    <img src={IMAGES.step_images_01} alt="" />
                  </div>
                  <div className="text">
                    <h6>Registration and Account</h6>
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page
                    </p>
                  </div>
                </div>
                <div className="image-box">
                  <div className="img">
                    <img src={IMAGES.step_images_02} alt="" />
                  </div>
                  <div className="text">
                    <h6>Browse and Select a Vehicle</h6>
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page
                    </p>
                  </div>
                </div>
                <div className="image-box">
                  <div className="img">
                    <img src={IMAGES.step_images_03} alt="" />
                  </div>
                  <div className="text">
                    <h6>Place Bids and Monitor</h6>
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="upcoming-auction latest-auction ongoing-auction">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <div className="bottom-line bottom-line-non">
                  <h2>
                    Ongoing <span>Auction</span>
                  </h2>
                </div>
              </div>
              <Slider {...auctionSettings}>
                {cardData.map((val) => (
                  <AuctionSlider item={val} key={val.id} />
                ))}
              </Slider>

              <div className="t-btn-center">
                <Button
                  text="View All Auctions"
                  primary={true}
                  icon={true}
                  onClick={() => console.log("View All Auctions clicked")}
                  style={{ fill: "black" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="download-sec"
        style={{
          backgroundImage: `url(${IMAGES.download_sec_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text">
                <h2>
                  Your Next Car Is Just a <span>Bid Away</span>
                </h2>
                <p>Download the App Now!</p>
              </div>
              <div className="apps-link-box-img">
                <a href="/">
                  <img src={IMAGES.google_play} alt="" />
                </a>
                <a href="/">
                  <img src={IMAGES.app_store} alt="" />
                </a>
              </div>
              <div className="download-mobile-img-abs">
                <img src={IMAGES.download_img_mobile} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="download-car-img-abs">
          <img src={IMAGES.download_img_car} alt="" />
        </div>
      </section>

      <FrequentlyAskedQuestions/>


    <Footer/>





    </div>
  );
};

export default Home;
